import React from 'react';
import FakeInfiniteScroll from '../FakeInfiniteScroll';
import BlogPostCard from './BlogPostCard';
import BlogCTA from './BlogCTA';
import BlogBanner from './BlogBanner';

const BlogRoll = ({ posts: postsProps, showAds, firstBig, location }) => {
  const posts = showAds
    ? postsProps
    : postsProps.filter(post => post.id !== 'cta');

  return (
    <FakeInfiniteScroll items={posts}>
      {postsChunked => {
        const showBanner = showAds && postsChunked.length >= 5;
        return (
          <div className="blog-roll">
            <div className="grid">
              {showBanner && (
                <BlogBanner
                  className="third-row"
                  title="Newsletter"
                  subtitle="Subscribe to our quarterly newsletter"
                  key="blogbanner"
                  showForm
                  location={location}
                />
              )}
              {postsChunked.map((post, idx) => {
                const isCTA = post.id === 'cta';
                return isCTA ? (
                  <BlogCTA key="cta" />
                ) : (
                  <BlogPostCard
                    post={post}
                    big={firstBig && idx === 0}
                    key={post.id}
                  />
                );
              })}
            </div>
          </div>
        );
      }}
    </FakeInfiniteScroll>
  );
};

export default BlogRoll;

BlogRoll.defaultProps = {
  showAds: true,
  firstBig: true
};
